import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { cardHover } from '@/theme/motion';

export type DestinationCardData = {
  id: string;
  name: string;
  image: string;
  guideCount: number;
  slug?: string;
};

type DestinationCardProps = {
  destination: DestinationCardData;
};

export function DestinationCard({ destination }: DestinationCardProps) {
  return (
    <Box component={motion.div} whileHover={cardHover} sx={{ height: '100%' }}>
      <Box
        component={RouterLink}
        to={destination.slug ? `/destinations?city=${destination.slug}` : '/destinations'}
        sx={{
          position: 'relative',
          display: 'block',
          height: { xs: 280, md: 360 },
          borderRadius: (t) => t.radii.lg,
          overflow: 'hidden',
          textDecoration: 'none',
          boxShadow: (t) => t.customShadows.card,
          transition: 'box-shadow 0.3s ease',
          '&:hover': { boxShadow: (t) => t.customShadows.hover },
        }}
      >
        <Box
          component="img"
          src={destination.image}
          alt={destination.name}
          loading="lazy"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background: (t) =>
              `linear-gradient(to top, ${alpha(t.palette.primary.main, 0.75)} 0%, transparent 60%)`,
          }}
        />
        <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, p: 3 }}>
          <Typography variant="h4" sx={{ color: 'textColors.white', fontWeight: 700 }}>
            {destination.name}
          </Typography>
          {destination.guideCount > 0 && (
            <Typography
              variant="body2"
              sx={{ color: (t) => alpha(t.palette.common.white, 0.85) }}
            >
              {destination.guideCount}+ Guides
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}
